document.addEventListener('DOMContentLoaded', function () {
  const TEXT_MAX_HEIGHT = 260;

  function checkSectionHeight(section, toggleButton) {
    const sectionHeight = section.scrollHeight;
    if (sectionHeight > TEXT_MAX_HEIGHT) {
      section.style.maxHeight = `${TEXT_MAX_HEIGHT}px`;
      section.style.overflow = 'hidden';
      section.classList.add('description-hidden');
      toggleButton.classList.remove('twcss-hidden');
    } else {
      toggleButton.classList.add('twcss-hidden');
    }
  }

  function handleToggle(section, toggleButton) {
    if (section.classList.contains('is-active')) {
      section.classList.remove('is-active');
      section.classList.add('description-hidden');
      section.style.maxHeight = `${TEXT_MAX_HEIGHT}px`;
      toggleButton.textContent = (window.variantStrings && window.variantStrings.showMore) || 'Show More';
    } else {
      section.classList.remove('description-hidden');
      section.classList.add('is-active');
      section.style.maxHeight = `${section.scrollHeight}px`;
      toggleButton.textContent = (window.variantStrings && window.variantStrings.showLess) || 'Show Less';
    }
  }

  document.querySelectorAll('.js-text-hidden').forEach(section => {
    const toggleButton = section.parentElement.querySelector('.js-collapse-btn');

    if (toggleButton) {
      checkSectionHeight(section, toggleButton);

      toggleButton.addEventListener('click', () => {
        handleToggle(section, toggleButton);
      });
    }
  });
});
